import React, { useCallback } from 'react';
import { useFormikContext, useField } from 'formik';

import {
  NAME,
  NO_PATIENT_REPORTS,
  NO_GP_REPORTS,
  NO_OPTICIAN_REPORTS,
  NO_REFERRALS,
  GENDER,
  GENDERS,
  CONSENT,
  CONSENTS,
  PATIENT_NAME,
  PATIENT_NAMES,
  NURSING_HOME_KIND,
  NURSING_HOME_KINDS,
  SEND_REPORTS_TO,
  REPORTS_TYPES,
  ISSUES_PRESCRIPTIONS,
} from 'store/organizations';
import { defineNursingHomeDataByKind } from 'store/organizations/utils';
import Checkbox from 'components/CheckboxNew';
import Radios from 'components/RadiosNew';
import Select from 'components/SelectNew';

import { Wrapper, Label, Text } from './styles';

const ReportsForm = () => {
  const { setValues } = useFormikContext();
  const [{ value: name }] = useField(NAME);
  const [{ value: noPatientReports }, , { setValue: setNoPatientReports }] = useField(NO_PATIENT_REPORTS);
  const [{ value: noGPReports }, , { setValue: setNoGPReports }] = useField(NO_GP_REPORTS);
  const [{ value: noOpticianReports }, , { setValue: setNoOpticianReports }] = useField(NO_OPTICIAN_REPORTS);
  const [{ value: noReferrals }, , { setValue: setNoReferrals }] = useField(NO_REFERRALS);
  const [{ value: gender }, , { setValue: setGender }] = useField(GENDER);
  const [{ value: consent }, , { setValue: setConsent }] = useField(CONSENT);
  const [{ value: patientName }, , { setValue: setPatientName }] = useField(PATIENT_NAME);
  const [{ value: nursingHomeKind }] = useField(NURSING_HOME_KIND);
  const [{ value: sendReportsTo }, , { setValue: setSendReportsTo }] = useField(SEND_REPORTS_TO);
  const [{ value: issuesPrescriptions }, , { setValue: setIssuesPrescriptions }] = useField(ISSUES_PRESCRIPTIONS);
  const onSelectNursingHomeKind = useCallback(
    (val) => {
      const kind = Number(val);

      setValues(($) => ({ ...$, [NURSING_HOME_KIND]: kind, ...defineNursingHomeDataByKind(kind) }));
    },
    [setValues]
  );

  return (
    <>
      <Select label="Berichte an" value={sendReportsTo} options={REPORTS_TYPES} onSelect={setSendReportsTo} />
      <Wrapper>
        <Label>Berichte</Label>
        <Checkbox label="Keine Berichte an Patienten senden" selected={noPatientReports} onClick={setNoPatientReports} />
        <div />
        <Checkbox label="Wünscht keine Berichte an Hausärzte" selected={noGPReports} onClick={setNoGPReports} />
        <div />
        <Checkbox label="Wünscht keine Berichte an Optiker" selected={noOpticianReports} onClick={setNoOpticianReports} />
      </Wrapper>
      <Wrapper>
        <Label>Überweisungen</Label>
        <Checkbox label="Wünscht keine Überweisungen" selected={noReferrals} onClick={setNoReferrals} />
      </Wrapper>
      <Radios value={gender} label="Artikel" items={GENDERS} setValue={setGender}>
        <Text>{name}</Text>
      </Radios>
      <Select label="Patienten ansprechen als" value={patientName} options={PATIENT_NAMES} onSelect={setPatientName} />
      <Select
        label="Art der Institution"
        value={nursingHomeKind}
        options={NURSING_HOME_KINDS}
        onSelect={onSelectNursingHomeKind}
      />
      <Select label="Einverständniserklärung" value={consent} options={CONSENTS} onSelect={setConsent} />
      <Wrapper>
        <Label>Rezepte</Label>
        <Checkbox
          label="Das Pflegeheim stellt Rezepte selbst aus"
          selected={issuesPrescriptions}
          onClick={setIssuesPrescriptions}
        />
      </Wrapper>
    </>
  );
};

export default ReportsForm;
